import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import IconReceipt from './icon/IconReceipt';
import { EIconReceiptType } from './icon/EIconReceiptType';

interface IProps {
  icon?: ReactNode
  iconLabel?: string
}

const Layout = (icon: IProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className="upload-left">
      <div className="icon-wrapper">
        <IconReceipt type={EIconReceiptType.UPLOAD} color='grey' />
      </div>

      <div className="doc-sub">
        {t('common.drag-file')}
        <span style={{ color: 'var(--primary)', fontWeight: 'bolder' }}>{
          t('common.browse-file')}
        </span>
      </div>
    </div>
  )
}

export default Layout;
